import { useCallback, useEffect, useState } from "react";
import { clientsApi } from "../api/clientsApi";
import type { Client } from "../types";

export function useDiySelfClient() {
  const [client, setClient] = useState<Client | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const reload = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const list = await clientsApi.getAll();
      const first = list[0] ?? null;
      if (!first) {
        setError("We could not find your client profile. Please contact support.");
      }
      setClient(first);
    } catch {
      setClient(null);
      setError("Could not load your profile. Check your connection and try again.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void reload();
  }, [reload]);

  return {
    client,
    clientId: client?.id ?? null,
    loading,
    error,
    reload,
  };
}
